import { render, staticRenderFns } from "./WJ.vue?vue&type=template&id=6e8cc544&"
import script from "./WJ.vue?vue&type=script&lang=js&"
export * from "./WJ.vue?vue&type=script&lang=js&"
import style0 from "./WJ.vue?vue&type=style&index=0&id=6e8cc544&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports